import { emailEvents } from '../emailEvent'
import { describeTable } from './describeTable'

describeTable(emailEvents, {
  description: `Delivery and consent events for system-sent email (Amazon SES), keyed by recipient address rather than by user. bounce and complaint rows are written from SES notifications and can be matched to the notifications row via message_id = notifications.external_message_id; unsubscribe rows are written when a recipient clicks the newsletter unsubscribe link (no message_id).
A recipient is suppressed from marketing mail when they have an 'unsubscribe' row or a bounce with bounce_type='Permanent'. Transient bounces do not suppress. A permanent bounce also flips the originating notification to status='bounced'.`,
  columns: {
    email:
      'Recipient address the event concerns (lower-case). Join users/customers on email, not on an id.',
    eventType:
      'bounce = SES could not deliver; complaint = recipient reported the mail as spam; unsubscribe = recipient opted out of marketing mail.',
    bounceType:
      "SES bounce class: 'Permanent' (hard bounce, address is dead — suppresses future marketing mail) or 'Transient' (temporary, e.g. mailbox full). NULL for non-bounce events.",
    bounceSubType:
      "SES detail, e.g. 'General', 'NoEmail', 'Suppressed', 'MailboxFull'.",
    complaintFeedbackType:
      "SES complaint type, e.g. 'abuse'. Only on complaint events.",
    diagnosticCode: 'SMTP diagnostic text from the receiving server.',
    messageId:
      'SES message id of the mail that bounced / was complained about; equals notifications.external_message_id.',
    timestamp:
      'When the event happened at SES (or when the unsubscribe click was made).',
  },
})
